import { render, staticRenderFns } from "./TenantSettingLayout.vue?vue&type=template&id=65d8bb45&"
import script from "./TenantSettingLayout.vue?vue&type=script&lang=js&"
export * from "./TenantSettingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports